export function AppDownloadBanner(props) {
    return (
        <div
            className="flex flex-col p-2 my-4 bg-gradient-to-r rounded-lg items-center from-white to-red-600">
            <div className="flex flex-wrap w-full items-center">
                <div className="md:w-1/3 w-full px-2 flex items-center justify-center">
                    <img className="w-full h-auto"
                         src="/favicons/favicon-32x32.png"
                         alt="STWH App Icon"/>
                </div>
                <div className="md:w-2/3 w-full my-2 md:my-0 text-white text-2xl text-center"> Holen Sie unsere
                    App!
                </div>
            </div>
            <button
                className="block rounded-lg mb-4 border border-white px-3 py-2 transition-colors ease-in-out duration-200 bg-transparent text-base font-medium text-white shadow hover:bg-white hover:text-red-600 sm:px-5"
            >
                App herunterladen!
            </button>
        </div>
    )
}

